import { BsdsInput } from '@bsds-lib-component/react';
import React, { useEffect, useId, useState } from 'react';

import { Dropdown } from '../..';
import type { SeguradoBeneficiarioFormValues } from '../../../types/vida/cadastralMaintenance/beneficiarioFormTypes';
import { getInputValue } from '../../../utils/insuredFormUtils';
import { SEGURADO_PARENTESCO_OPTIONS } from '../../../utils/parentescoUtils';
import {
  EMPTY_SEGURADO_BENEFICIARIO_FORM_VALUES,
  isSeguradoBeneficiarioFormValid,
  NM_BENEFICIARIO_MAX_LENGTH,
} from '../../../utils/beneficiarioFormUtils';

type SeguradoBeneficiarioFormSectionProps = {
  initialValues?: SeguradoBeneficiarioFormValues;
  readOnly?: boolean;
  onValidityChange?: (isValid: boolean) => void;
  onValuesChange?: (values: SeguradoBeneficiarioFormValues) => void;
};

const SeguradoBeneficiarioFormSection: React.FC<SeguradoBeneficiarioFormSectionProps> = ({
  initialValues,
  readOnly = false,
  onValidityChange,
  onValuesChange,
}) => {
  const parentescoDropdownId = useId();
  const [values, setValues] = useState<SeguradoBeneficiarioFormValues>(
    initialValues ?? EMPTY_SEGURADO_BENEFICIARIO_FORM_VALUES,
  );

  useEffect(() => {
    setValues(initialValues ?? EMPTY_SEGURADO_BENEFICIARIO_FORM_VALUES);
  }, [initialValues]);

  useEffect(() => {
    onValidityChange?.(isSeguradoBeneficiarioFormValid(values));
    onValuesChange?.(values);
  }, [values, onValidityChange, onValuesChange]);

  const handleInputChange = (field: keyof SeguradoBeneficiarioFormValues) => (
    event: React.FormEvent<HTMLBsdsInputElement>,
  ) => {
    if (readOnly) {
      return;
    }
    const value = getInputValue(event);
    setValues((current) => ({ ...current, [field]: value }));
  };

  return (
    <div role="region" aria-label="Dados do beneficiário do segurado">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <BsdsInput
          label="Nome do Beneficiário *"
          value={values.nomeBeneficiario}
          onInput={handleInputChange('nomeBeneficiario')}
          type="text"
          platform="web"
          required
          disabled={readOnly}
          clearInput={false}
          maxlength={NM_BENEFICIARIO_MAX_LENGTH}
        />
        <Dropdown
          id={parentescoDropdownId}
          label="Parentesco *"
          placeholder="Selecione o parentesco"
          value={values.codTipoParentesco}
          onChange={(value) => {
            if (readOnly) {
              return;
            }
            setValues((current) => ({ ...current, codTipoParentesco: value }));
          }}
          options={SEGURADO_PARENTESCO_OPTIONS}
          required
          disabled={readOnly}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 bsds-mt-16">
        <BsdsInput
          label="Percentual *"
          value={values.percentualPart}
          onInput={handleInputChange('percentualPart')}
          type="text"
          inputmode="decimal"
          platform="web"
          required
          disabled={readOnly}
          clearInput={false}
        />
      </div>
    </div>
  );
};

export default SeguradoBeneficiarioFormSection;
